export default __webpack_public_path__ + "static/media/boleto.f9c5e1bd.svg";